import React, { useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Schedule from "./components/Schedule";
import Locations from "./components/Locations";
import Catering from "./components/Catering";
import RSVP from "./components/RSVP";
import Footer from "./components/Footer";
import WishlistPage from "./components/WishlistPage";
import GalleryPage from "./components/GalleryPage";
import "./App.css";

function HomePage() {
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (isLoading) return;
    const hash = location.hash.replace(/^#/, "");
    if (!hash) return;
    const el = document.getElementById(hash);
    if (el) {
      requestAnimationFrame(() => {
        el.scrollIntoView({ behavior: "smooth" });
      });
    }
  }, [isLoading, location.hash]);

  if (isLoading) {
    return (
      <div className="loading-screen">
        <div className="loading-content">
          <h2>Lars & Guro</h2>
          <div className="loading-spinner"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <Navbar />
      <main>
        <Hero />
        <Schedule />
        <Locations />
        <Catering />
        <RSVP />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/wishlist" element={<WishlistPage />} />
      <Route path="/galleri" element={<GalleryPage />} />
      <Route path="*" element={<HomePage />} />
    </Routes>
  );
}

export default App;
